import { OfferedServices } from "@/lib/types";
// Images
import {
  BrandBg,
  SaasBg,
  WebBg,
  VideoBg,
  BrandP1,
  BrandP2,
  BrandP3,
  BrandP4,
  BrandP5,
  BrandP6,
  Slider1,
  Slider2,
  Slider3,
  Slider4,
  Slider5,
} from "@/assets/images/image";
import {
  ServiceIcon1,
  ServiceIcon2,
  ServiceIcon3,
  ServiceIcon4,
} from "@/assets/icons/MainPageIcon";

export const ServicesData: OfferedServices[] = [
  {
    id: "01",
    slug: "brand-identity",
    title: "BRAND IDENTITY.",
    description:
      "Creating a strong brand identity helps your business stand out and connect with your audience.",
    introDescription:
      "Creating a strong brand identity helps your business stand out and connect with your audience. Our services focus on understanding your core values and making sure they come through clearly. We work closely with you to build a consistent and meaningful brand presence.",
    icon: ServiceIcon1,
    features: [
      "Logo Design",
      "Corporate Identity",
      "Pitch Decks",
      "Social Media",
    ],
    images: [
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=600",
      "https://images.unsplash.com/photo-1558655146-d09347e92766?q=80&w=600",
      "https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?q=80&w=600",
      "https://images.unsplash.com/photo-1550684848-fac1c5b4e853?q=80&w=600",
    ],
    heroImage: BrandBg,
    subFeatures: [
      {
        title: "LOGO DESIGN",
        points: ["Simplicity", "Balance", "Scalability", "Contrast"],
      },
      {
        title: "CORPORATE IDENTITY",
        points: [
          "Brand Guidelines",
          "Stationery",
          "Visual Language",
          "Iconography",
        ],
      },
      {
        title: "PITCH & PRESENTATIONS",
        points: ["Deck Design", "Data Visualization", "Storytelling", "Layout"],
      },
      {
        title: "SOCIAL MEDIA ASSETS",
        points: ["Templates", "Motion Graphics", "Content Strategy", "Styling"],
      },
    ],
    process: [
      {
        number: "01",
        title: "Strategy",
        description:
          "Every powerful logo begins with clarity. We start by understanding your brand's purpose, audience, positioning, and long-term vision. Through structured discovery and research, we uncover what makes you different — and how your identity should communicate that difference.",
        subPoints: [
          "Brand Discovery",
          "Market Research",
          "Audience Insights",
          "Positioning & Direction",
          "Sketch Exploration",
          "Typography Studies",
          "Symbol Development",
          "Concept Presentation",
        ],
      },
      {
        number: "02",
        title: "Discovery",
        description:
          "Before the first sketch, we immerse ourselves in your world. We analyze the landscape to ensure your brand doesn't just fit in, but leads the conversation and sets new standards in your specific industry niche through deep research and stakeholder context.",
        subPoints: [
          "Stakeholder Interviews",
          "Industry Trends",
          "Consumer Behavior",
          "Visual Audit",
          "Touchpoint Mapping",
          "Cultural Context",
          "Narrative Strategy",
          "Mind Mapping",
        ],
      },
      {
        number: "03",
        title: "Concept",
        description:
          "Ideas take shape through exploration. We translate insights into multiple creative directions, experimenting with form, typography, and symbolism to capture your brand essence in visual form while ensuring timeless and scalable design foundations.",
        subPoints: [
          "Sketch Exploration",
          "Symbol Design",
          "Typography Customization",
          "Concept Presentation",
          "Concept Rationale",
          "Logo Variations",
          "Visual Testing",
          "Presentation Mockups",
        ],
      },
      {
        number: "04",
        title: "Refinement",
        description:
          "Great design lives in the details. Once a direction is selected, we refine proportions, spacing, alignment, and balance to achieve visual harmony and precision. Every curve and angle is optimized for clarity and impact across all brand touch points.",
        subPoints: [
          "Grid System",
          "Vector Precision",
          "Color System",
          "Feedback Loop",
          "Proportion Adjustments",
          "Scalability Testing",
          "Responsive Versions",
          "Feedback Iteration",
        ],
      },
      {
        number: "05",
        title: "Brand System",
        description:
          "A logo is not just one file — it's a system. We prepare a complete set of assets to ensure consistency across all touch points, from digital platforms to print materials, empowering your team with clear and comprehensive usage guidelines.",
        subPoints: [
          "Icon & Favicon Versions",
          "Monochrome Variations",
          "AI / EPS / SVG / PNG Files",
          "Brand Guidelines",
          "Typography Palette",
          "Digital Product Assets",
          "Brand Architecture",
          "Brand Storybook",
        ],
      },
    ],
    portfolio1: {
      subtitle: "Visual Identity",
      title: "Building Brands With Clarity & Purpose",
      description:
        "We craft cohesive visual identities that align strategy with design — helping brands communicate with confidence. Through thoughtful branding, we create identities that position your brand for long-term growth.",
      ctaText: "CONTACT",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP1,
          title: "Photo Manipulation",
          tag: "Visual Identity",
          caseStudyLink: "/case-study/chic-charming",
        },
        {
          src: BrandP2,
          title: "Branding & Logo",
          tag: "Identity",
          caseStudyLink: "/case-study/chic-charming",
        },
        {
          src: BrandP3,
          title: "Corporate Branding",
          tag: "Strategy",
          caseStudyLink: "/case-study/chic-charming",
        },
      ],
    },
    sliderImages: [
      { id: "s1", src: Slider1, alt: "Slider 1" },
      { id: "s2", src: Slider2, alt: "Slider 2" },
      { id: "s3", src: Slider3, alt: "Slider 3" },
      { id: "s4", src: Slider4, alt: "Slider 4" },
      { id: "s5", src: Slider5, alt: "Slider 5" },
    ],
    portfolio2: {
      subtitle: "Strategic Assets",
      title: "Impactful Design for Modern Businesses",
      description:
        "We deliver visual assets that cut through the noise. From marketing materials to digital touchpoints, our design system ensures your brand remains memorable and professional.",
      ctaText: "CONTACT",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP4,
          title: "Pitch Deck UI",
          tag: "Presentation",
          caseStudyLink: "/case-study/artevic-media",
        },
        {
          src: BrandP5,
          title: "Social Assets",
          tag: "Motion",
          caseStudyLink: "/case-study/artevic-media",
        },
        {
          src: BrandP6,
          title: "Brand Book",
          tag: "Print",
          caseStudyLink: "/case-study/artevic-media",
        },
      ],
    },
    gallery: {
      col1: [
        {
          id: "g1",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 1",
        },
        {
          id: "g2",
          src: "https://images.unsplash.com/photo-1550684376-efcbd6e3f031?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 2",
        },
        {
          id: "g3",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 3",
        },
        {
          id: "g4",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 4",
        },
      ],
      col2: [
        {
          id: "g5",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g6",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g7",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g8",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
      col3: [
        {
          id: "g9",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 9",
        },
        {
          id: "g10",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 10",
        },
        {
          id: "g11",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 11",
        },
        {
          id: "g12",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 12",
        },
      ],
      col4: [
        {
          id: "g13",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g16",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
    },
    metadata: {
      title: "BRAND IDENTITY | Octarnal",
      description:
        "Brand identity built from your core values out — naming, logo design, corporate identity and a system your team can hold to.",
      keywords: [
        "Logo Design",
        "Corporate Identity",
        "Pitch Decks",
        "Social Media",
      ],
      ogImage: "/openg.jpg",
    },
  },
  {
    id: "02",
    slug: "saas-application",
    title: "SAAS PRODUCT.",
    description:
      "We design and develop scalable SaaS applications that transform ideas into powerful digital products.",
    introDescription:
      "Our SaaS solutions focus on bridging the gap between complex functionality and seamless user experience. We build applications that not only look stunning but perform at scale for global users through precision engineering.",
    icon: ServiceIcon2,
    features: [
      "Product Strategy",
      "UI/UX Platforms",
      "Scalable Backend",
      "Cloud Integration",
    ],
    images: [
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=600",
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=600",
      "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=600",
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=600",
    ],
    heroImage: SaasBg,
    subFeatures: [
      {
        title: "UX ARCHITECTURE",
        points: ["User Flow", "Wireframing", "Prototyping", "Hierarchy"],
      },
      {
        title: "UI DESIGN",
        points: [
          "Design Systems",
          "Component Library",
          "Dark Mode",
          "Accessibility",
        ],
      },
      {
        title: "BACKEND DEV",
        points: ["Scalability", "Security", "API Design", "Performance"],
      },
      {
        title: "DATA VISUALS",
        points: ["Charts", "Dashboards", "Reporting", "Insights"],
      },
    ],
    process: [
      {
        number: "01",
        title: "Product Strategy",
        description:
          "Success in SaaS begins with a solid strategic foundation. We work deeply into your product core to define a roadmap that balances business goals with real-world user needs and long-term technical growth opportunities.",
        subPoints: [
          "Market Mapping",
          "User Personas",
          "Feature Prioritization",
          "Tech Audit",
          "Competitive Audit",
          "Pricing Strategy",
          "Product Roadmap",
          "KPI Foundation",
        ],
      },
      {
        number: "02",
        title: "UX Engineering",
        description:
          "We design for efficiency and scale. Our focus is on creating seamless user flows that reduce friction and enhance user retention, ensuring your product remains powerful yet intuitive for every single user persona.",
        subPoints: [
          "Wireframe Assets",
          "Interactive Prototypes",
          "User Flow Mapping",
          "Usability Testing",
          "Information Architecture",
          "Edge Case Design",
          "Accessibility Standards",
          "Micro-interactions",
        ],
      },
      {
        number: "03",
        title: "Design System",
        description:
          "Consistency is key to a premium product. We build comprehensive design systems that empower your product to scale elegantly, maintaining a unified visual language across every feature, platform, and user touchpoint.",
        subPoints: [
          "Component Library",
          "Design Tokens",
          "Grid Definitions",
          "Iconography Set",
          "Typography System",
          "Dark Mode Support",
          "Documentation",
          "Visual Specs",
        ],
      },
      {
        number: "04",
        title: "Development",
        description:
          "We bring products to life through clean code. Using modern frameworks and scalable backend cloud architecture, we ensure your SaaS platform is lightning-fast, secure, and ready to handle high-traffic production environments.",
        subPoints: [
          "API Integration",
          "Frontend Logic",
          "Database Model",
          "Security Layer",
          "Performance Audit",
          "Unit Testing",
          "DevOps Setup",
          "Code Optimization",
        ],
      },
      {
        number: "05",
        title: "Growth & Iteration",
        description:
          "Launch is only the beginning. We manage a smooth deployment and set up continuous monitoring to gather real user data, allowing us to rapidly evolve and iterate your product for market-leading excellence.",
        subPoints: [
          "Analytics Install",
          "Error Monitoring",
          "Feedback Loops",
          "A/B Testing Cycle",
          "Performance Tuning",
          "CI/CD Pipeline",
          "User Onboarding",
          "Future Scaling",
        ],
      },
    ],
    portfolio1: {
      subtitle: "Enterprise Platforms",
      title: "Designing for Complex Ecosystems",
      description:
        "We transform complex data into intuitive administrative panels. Our focus is on high-load stability and seamless visualization that drives business growth.",
      ctaText: "EXPLORE",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP1,
          title: "Analytics Panel",
          tag: "Enterprise",
          caseStudyLink: "/case-study/artevic-media",
        },
        {
          src: BrandP2,
          title: "Data Dashboard",
          tag: "Product",
          caseStudyLink: "/case-study/artevic-media",
        },
        {
          src: BrandP3,
          title: "SaaS Workflow",
          tag: "System",
          caseStudyLink: "/case-study/artevic-media",
        },
      ],
    },
    sliderImages: [
      { id: "s1", src: Slider1, alt: "Slider 1" },
      { id: "s2", src: Slider2, alt: "Slider 2" },
      { id: "s3", src: Slider3, alt: "Slider 3" },
      { id: "s4", src: Slider4, alt: "Slider 4" },
      { id: "s5", src: Slider5, alt: "Slider 5" },
    ],
    portfolio2: {
      subtitle: "User Retention",
      title: "Optimizing the User Experience",
      description:
        "We engineer micro-interactions that keep users engaged. By focusing on psychological triggers, we ensure your app feels like a natural part of the user's workflow.",
      ctaText: "CONTACT",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP4,
          title: "Mobile UI Flow",
          tag: "UX Research",
          caseStudyLink: "/case-study/artevic-media",
        },
        {
          src: BrandP5,
          title: "Interaction Design",
          tag: "Interface",
          caseStudyLink: "/case-study/artevic-media",
        },
        {
          src: BrandP6,
          title: "Retention Audit",
          tag: "Strategy",
          caseStudyLink: "/case-study/artevic-media",
        },
      ],
    },
    gallery: {
      col1: [
        {
          id: "g1",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 1",
        },
        {
          id: "g2",
          src: "https://images.unsplash.com/photo-1550684376-efcbd6e3f031?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 2",
        },
        {
          id: "g3",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 3",
        },
        {
          id: "g4",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 4",
        },
      ],
      col2: [
        {
          id: "g5",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g6",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g7",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g8",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
      col3: [
        {
          id: "g9",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 9",
        },
        {
          id: "g10",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 10",
        },
        {
          id: "g11",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 11",
        },
        {
          id: "g12",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 12",
        },
      ],
      col4: [
        {
          id: "g13",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g16",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
    },
    metadata: {
      title: "SAAS PRODUCT | Octarnal",
      description:
        "SaaS product design and development that keeps complex functionality usable — and keeps performing once the user count grows.",
      keywords: [
        "Product Strategy",
        "UI/UX Platforms",
        "Scalable Backend",
        "Cloud Integration",
      ],
      ogImage: "/openg.jpg",
    },
  },
  {
    id: "03",
    slug: "web-development",
    title: "WEB SOLUTIONS.",
    description:
      "We build high-performance websites that combine seamless user experience with scalable architecture.",
    introDescription:
      "Our web development process is focused on speed, security, and conversion-driven technical excellence. We build digital homes that represent your brand while delivering measurable results for your growing business.",
    icon: ServiceIcon3,
    features: [
      "Custom Development",
      "Responsive Design",
      "CMS Solutions",
      "Performance",
    ],
    images: [
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=600",
      "https://images.unsplash.com/photo-1518779578993-ec3579fee39f?q=80&w=600",
      "https://images.unsplash.com/photo-1492724441997-5dc865305da7?q=80&w=600",
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=600",
    ],
    heroImage: WebBg,
    subFeatures: [
      {
        title: "FRONTEND TECH",
        points: [
          "React / Next.js",
          "Performance",
          "Responsive",
          "Interactions",
        ],
      },
      {
        title: "SYSTEM ARCH.",
        points: ["Headless CMS", "Cloud Setup", "Microservices", "Security"],
      },
      {
        title: "E-COMMERCE",
        points: ["Shopify", "Custom Checkout", "Inventory", "Payments"],
      },
      {
        title: "SEO ENGINES",
        points: ["Core Web Vitals", "Semantics", "Indexing", "Analytics"],
      },
    ],
    process: [
      {
        number: "01",
        title: "Digital Blueprint",
        description:
          "A great website starts with a strategic plan. We analyze your brand goals and user needs to create a technical blueprint that guides every design and development decision throughout the entire project lifecycle.",
        subPoints: [
          "Requirement Gathering",
          "SEO Strategy",
          "Sitemap Design",
          "Technical Spec",
          "Content Inventory",
          "Conversion Goals",
          "Project Roadmap",
          "Timeline Setup",
        ],
      },
      {
        number: "02",
        title: "Visual Design",
        description:
          "We design for engagement and conversion. Our focus is on creating immersive visual experiences that captivate visitors from the first click and guide them naturally toward your primary business objectives.",
        subPoints: [
          "Creative Direction",
          "UI Style Guide",
          "Responsive Grids",
          "Typography Selection",
          "Image Optimization",
          "Accessibility Plan",
          "Mobile Layouts",
          "Design Approval",
        ],
      },
      {
        number: "03",
        title: "Development",
        description:
          "We translate designs into high-performance code. Our team focuses on clean, semantic architecture using the latest technologies to ensure your website is lightning-fast, secure, and future-proof.",
        subPoints: [
          "Frontend Framework",
          "Headless CMS Setup",
          "API Integration",
          "Dynamic Content",
          "Performance Tuning",
          "Security Layer",
          "QC Walkthrough",
          "Browser Testing",
        ],
      },
      {
        number: "04",
        title: "Testing & QA",
        description:
          "Quality is non-negotiable. Before launch, we put your website through rigorous testing across all devices and browsers to ensure seamless performance, security, and an error-free user journey.",
        subPoints: [
          "Cross-browser Test",
          "Mobile Device Check",
          "Speed Optimization",
          "SEO Final Audit",
          "Security Hardening",
          "Link Validation",
          "Form Testing",
          "Analytics Setup",
        ],
      },
      {
        number: "05",
        title: "Deployment",
        description:
          "We manage the transition to a live environment with care. We set up reliable hosting, SSL certificates, and post-launch monitoring to ensure your brand's digital home stays fast and secure.",
        subPoints: [
          "Server Config",
          "SSL Integration",
          "Database Migration",
          "CDN Setup",
          "Performance Monitor",
          "Maintenance Plan",
          "Final Handover",
          "Growth Check",
        ],
      },
    ],
    portfolio1: {
      subtitle: "Full-Stack Web",
      title: "Digital Ecosystems Built for Performance",
      description:
        "We build digital homes that represent your brand while delivering results. Our headless solutions ensure your web presence is future-proof and fast.",
      ctaText: "CONTACT",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP1,
          title: "Corporate Portal",
          tag: "Next.js",
          caseStudyLink: "/case-study/moson-media",
        },
        {
          src: BrandP2,
          title: "Agency Portfolio",
          tag: "Creative",
          caseStudyLink: "/case-study/moson-media",
        },
        {
          src: BrandP3,
          title: "E-commerce System",
          tag: "Shopify",
          caseStudyLink: "/case-study/moson-media",
        },
      ],
    },
    sliderImages: [
      { id: "s1", src: Slider1, alt: "Slider 1" },
      { id: "s2", src: Slider2, alt: "Slider 2" },
      { id: "s3", src: Slider3, alt: "Slider 3" },
      { id: "s4", src: Slider4, alt: "Slider 4" },
      { id: "s5", src: Slider5, alt: "Slider 5" },
    ],
    portfolio2: {
      subtitle: "React Specialist",
      title: "Next-Gen Web Architecture",
      description:
        "Specializing in React systems that scale. Every component is optimized for Core Web Vitals, ensuring your brand stays at the top of search rankings.",
      ctaText: "CONTACT",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP4,
          title: "SaaS Dashboard",
          tag: "React",
          caseStudyLink: "/case-study/moson-media",
        },
        {
          src: BrandP5,
          title: "Performance Portal",
          tag: "Vercel",
          caseStudyLink: "/case-study/moson-media",
        },
        {
          src: BrandP6,
          title: "Dynamic Logic",
          tag: "Architecture",
          caseStudyLink: "/case-study/elorva-perfumes",
        },
      ],
    },
    gallery: {
      col1: [
        {
          id: "g1",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 1",
        },
        {
          id: "g2",
          src: "https://images.unsplash.com/photo-1550684376-efcbd6e3f031?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 2",
        },
        {
          id: "g3",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 3",
        },
        {
          id: "g4",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 4",
        },
      ],
      col2: [
        {
          id: "g5",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g6",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g7",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g8",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
      col3: [
        {
          id: "g9",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 9",
        },
        {
          id: "g10",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 10",
        },
        {
          id: "g11",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 11",
        },
        {
          id: "g12",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 12",
        },
      ],
      col4: [
        {
          id: "g13",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g16",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
    },
    metadata: {
      title: "WEB SOLUTIONS | Octarnal",
      description:
        "High-performance websites built for speed, security and conversion — your brand online, with a number attached to the outcome.",
      keywords: [
        "Custom Development",
        "Responsive Design",
        "CMS Solutions",
        "Performance",
      ],
      ogImage: "/openg.jpg",
    },
  },
  {
    id: "04",
    slug: "video-editing",
    title: "VISUAL STORY.",
    description:
      "We create compelling visual stories that capture attention and elevate your brand presence.",
    introDescription:
      "Video is the most powerful tool for connection in the digital age. We refine your raw footage into cinematic stories that capture hearts and drive real engagement for your brand.",
    icon: ServiceIcon4,
    features: [
      "Post Production",
      "Motion Graphics",
      "Commercial Ads",
      "Storytelling",
    ],
    images: [
      "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?q=80&w=600",
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=600",
      "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?q=80&w=600",
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=600",
    ],
    heroImage: VideoBg,
    subFeatures: [
      {
        title: "POST PRODUCTION",
        points: ["Color Grading", "Sound Design", "Narrative Flow", "Pacing"],
      },
      {
        title: "MOTION GRAPHICS",
        points: ["2D/3D Titles", "Transitions", "VFX", "Animations"],
      },
      {
        title: "COMMERCIALS",
        points: ["Ad Creative", "Social Clips", "High-Impact", "B-roll"],
      },
      {
        title: "STORYTELLING",
        points: ["Scripting", "Direction", "Atmosphere", "Engagement"],
      },
    ],
    process: [
      {
        number: "01",
        title: "Storyboarding",
        description:
          "Every great video starts with a narrative vision. We collaborate to define the script, mood, and visual style that will best communicate your message and captivate your target audience.",
        subPoints: [
          "Scripting Core",
          "Storyboarding Path",
          "Mood Definition",
          "Creative Direction",
          "Asset Audit",
          "Narrative Arc",
          "Visual Research",
          "Shot Listing",
        ],
      },
      {
        number: "02",
        title: "Production",
        description:
          "We bring stories into focus. Whether on-site or in-studio, our focus is on high-quality cinematography and lighting to ensure every frame contributes to a premium atmospheric narrative.",
        subPoints: [
          "Cinematography",
          "Lighting Setup",
          "Audio Capture",
          "Directing Polish",
          "Gear Management",
          "Backup Protocols",
          "B-roll Selection",
          "Interview Staging",
        ],
      },
      {
        number: "03",
        title: "The Edit",
        description:
          "The magic happens in the suite. We meticulously select and assemble the best footage to create a rhythmic and emotionally resonant story that keeps viewers engaged from start to finish.",
        subPoints: [
          "Footage Review",
          "Assembly Cut",
          "Pacing & Rhythm",
          "Sound Design",
          "Assembly Review",
          "Rough Cut Polish",
          "Multi-cam Sync",
          "Context Check",
        ],
      },
      {
        number: "04",
        title: "Visual FX",
        description:
          "We add the cinematic layer. Through professional color grading, motion graphics, and VFX, we enhance the mood and atmosphere to meet world-class industry and broadcast standards.",
        subPoints: [
          "Color Grading",
          "Motion Titles",
          "VFX Integration",
          "Audio Mastering",
          "Lighting Fix",
          "VFX Polish",
          "Visual Effects",
          "Atmospheric Tone",
        ],
      },
      {
        number: "05",
        title: "Delivery",
        description:
          "We prepare your story for the world. We export high-quality versions optimized for every platform, ensuring your brand message reaches your audience with maximum impact and clarity.",
        subPoints: [
          "Format Exports",
          "Social Optimization",
          "Master Rendering",
          "Subtitle Prep",
          "Asset Packaging",
          "Platform Checks",
          "Final Handover",
          "Archival Storage",
        ],
      },
    ],
    portfolio1: {
      subtitle: "Cinematography",
      title: "Moving Stories That Capture Hearts",
      description:
        "We don't just edit; we sculpt emotions. Every frame carries the weight of your brand's intention through professional color grading.",
      ctaText: "CONTACT",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP1,
          title: "Brand Narrative",
          tag: "Cinematic",
          caseStudyLink: "/case-study/moson-media",
        },
        {
          src: BrandP2,
          title: "Product Promo",
          tag: "VFX",
          caseStudyLink: "/case-study/moson-media",
        },
        {
          src: BrandP3,
          title: "Social Story",
          tag: "Motion",
          caseStudyLink: "/case-study/moson-media",
        },
      ],
    },
    sliderImages: [
      { id: "s1", src: Slider1, alt: "Slider 1" },
      { id: "s2", src: Slider2, alt: "Slider 2" },
      { id: "s3", src: Slider3, alt: "Slider 3" },
      { id: "s4", src: Slider4, alt: "Slider 4" },
      { id: "s5", src: Slider5, alt: "Slider 5" },
    ],
    portfolio2: {
      subtitle: "Post-Production",
      title: "Precision Editing for High-End Ads",
      description:
        "Professional editing is about the invisible cuts that build a master story. We deliver broadcast-ready commercials that demand attention.",
      ctaText: "CONTACT",
      ctaLink: "/contact",
      items: [
        {
          src: BrandP4,
          title: "VFX Breakdown",
          tag: "Editing",
          caseStudyLink: "/case-study/elorva-perfumes",
        },
        {
          src: BrandP5,
          title: "Color Grade",
          tag: "Cinematic",
          caseStudyLink: "/case-study/elorva-perfumes",
        },
        {
          src: BrandP6,
          title: "Production House",
          tag: "Ad",
          caseStudyLink: "/case-study/elorva-perfumes",
        },
      ],
    },
    gallery: {
      col1: [
        {
          id: "g1",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 1",
        },
        {
          id: "g2",
          src: "https://images.unsplash.com/photo-1550684376-efcbd6e3f031?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 2",
        },
        {
          id: "g3",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 3",
        },
        {
          id: "g4",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 4",
        },
      ],
      col2: [
        {
          id: "g5",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g6",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g7",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g8",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
      col3: [
        {
          id: "g9",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 9",
        },
        {
          id: "g10",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 10",
        },
        {
          id: "g11",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 11",
        },
        {
          id: "g12",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 12",
        },
      ],
      col4: [
        {
          id: "g13",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 5",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 6",
        },
        {
          id: "g14",
          src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
          alt: "Gallery 7",
        },
        {
          id: "g16",
          src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
          alt: "Gallery 8",
        },
      ],
    },
    metadata: {
      title: "VISUAL STORY | Octarnal",
      description:
        "Raw footage cut into cinematic stories — brand films, promos, podcasts and reels that hold attention and drive engagement.",
      keywords: [
        "Post Production",
        "Motion Graphics",
        "Commercial Ads",
        "Storytelling",
      ],
      ogImage: "/openg.jpg",
    },
  },
];
